export default __webpack_public_path__ + "static/media/meal.e3fbb2d7.svg";